export const typeList ={
    '1':'好评',
    '2':'差评',
    '3':'用户画像',
    '4':'使用场景',
    '5':'购买动机',
    '6':'决策因素'
}

export const getSessionStore = name => {
    if(! name) return;
    return sessionStorage.getItem(name);
}



// WEBPACK FOOTER //
// ./src/components/util/util.js